import React, { useState } from "react";
import { useGet } from "../../services/GetService";

 const SendMail = ({ id }) => {
    const [send, setSend] = useGet(`form/send/${id}`);
    return <>
    <td>{send.sent}</td>
    {/* <td>{send.open}</td>
    <td>{send.error}</td> */}


    </>;
};


export const OpenMail = ({ id }) => {
    const [open, setOpen] = useGet(`form/open/${id}`);
    return <p>{open}</p>;
};

export const ErrorMail = ({ id }) => {
    const [error, setError] = useGet(`form/error/${id}`);
    return <p>{error}</p>;
};

export default SendMail;
